import React from "react";
import { Typography } from "@mui/material";

const MyTitle = ({ text }) => {
  return (
    <Typography
      sx={{
        mb: 0.5,
        textAlign: "center",
        fontWeight: "bold",
      }}
      variant="subtitle2"
      id="tableTitle"
      component="div"
    >
      {text}
    </Typography>
  );
};
export default MyTitle;
